import api from 'app/api';
import { toCamelCase } from 'app/utils';
import { errorToast } from 'app/utils/toast';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import store from 'store';
import {
  setFeatureFlagLoading,
  setFeatureFlags,
  setIsUrOrEnabled,
  setLoadedSubscriptionId,
} from 'store/common/actions';
import { SaveTableStructure } from 'store/dataLibrary/actions';
import {
  saveFileSetTableStructure,
  saveLotTableStructure,
  SaveUsecaseRoutingTableStructure,
  SaveWaferTableStructure,
  setImageFit,
} from 'store/helpers/actions';

const useMetaFiltersLoad = () => {
  const { subscriptionId } = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    if (subscriptionId) {
      dispatch(setFeatureFlagLoading(true));
      api
        .getSubscription(subscriptionId)
        .then(res => {
          if (res.feature_flags) {
            const featureFlags = Object.fromEntries(
              Object.entries(res.feature_flags).map(([key, value]) => [
                toCamelCase(key),
                value,
              ])
            );
            dispatch(setFeatureFlags(featureFlags));
            dispatch(
              setIsUrOrEnabled(res.feature_flags.is_ur_or_enabled ?? false)
            ); //ToDo: Considering the involvement of uror testing keeping it for now, later need to remove it and fetch uror feature flag as well from common globally created feature flags object
          }

          dispatch(setFeatureFlagLoading(false));
          dispatch(setLoadedSubscriptionId(subscriptionId));

          if (res.image_fit !== store.getState().helpers.imageFit) {
            dispatch(setImageFit(res.image_fit));
          }

          dispatch(SaveWaferTableStructure(res.wafer_map_meta_info));
          dispatch(saveLotTableStructure(res.lot_meta_info));
          dispatch(saveFileSetTableStructure(res.file_set_meta_info));
          dispatch(
            SaveUsecaseRoutingTableStructure(
              res.usecase_routing_information_schema?.routing_keys_config
            )
          );

          if (res.file_set_meta_info?.length) {
            dispatch(SaveTableStructure(res.file_set_meta_info));
          }
        })
        .catch(() => {
          dispatch(setFeatureFlagLoading(false));
          dispatch(setLoadedSubscriptionId(null));
          errorToast('Failed to load meta filters.');
        });
    } else {
      dispatch(setFeatureFlagLoading(false));
      dispatch(setLoadedSubscriptionId(null));
    }
  }, [subscriptionId]);

  return null;
};

export default useMetaFiltersLoad;
